import { requireModule } from '../../../auth/guards';
import { MODULES } from '../../../auth/permissions';
import DisciplineBoardPage from './pages/DisciplineBoard';

export const feedbackRoutes = [
  {
    path: '/discipline-board',
    loader: requireModule(MODULES.FEEDBACK),
    element: <DisciplineBoardPage />,
  },
];
